import { useReducer } from 'react';
/*
     this reducer allows us to force a re-render of our component
     the useRef below stores the current values of all the fields, in a form suitable to send to the server
     we could put this in state, but that duplication isn't necessary as we can simulate this - we probably should be a bit smarter
     but for now this works

     ...basically if you want your component to re-render -> put this hook in there and call render() whenver you want to re-render =]
*/
export const useRenderer = () => {
	const [_, render] = useReducer(a => !a, false);

	return render;
};
